<template>
  <a-config-provider :locale="localeStore.antdLocale" :theme="antdTheme">
    <router-view />
  </a-config-provider>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useLocaleStore } from '@/stores/locale'

const localeStore = useLocaleStore()

const antdTheme = computed(() => ({
  token: {
    colorPrimary: '#722ed1',
    borderRadius: 4,
    fontSize: 14,
  },
}))
</script>

<style lang="less">
@import '@/styles/theme.less';

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: @text-color;
}

.ant-menu {
  .ant-menu-item {
    &::after {
      display: none !important;
    }
  }
}
</style>
